import React, { useRef } from "react";
import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
import Header from "../../pages/LandingPage/Navbar";
import BannerImg from "../../assets/Blog_Banner.jpg";
import { Helmet } from "react-helmet";
import { IconButton } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/FavoriteBorder";
import ShareIcon from "@mui/icons-material/ShareOutlined";
import PrintIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { useReactToPrint } from "react-to-print";
import { useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import howbarterimage from "../../assets/Images/LearnBarterImages/howbarterimage.webp"

const ResponsiveImage = ({ src, alt, sx }) => (
  <Box
    component="img"
    src={src}
    alt={alt}
    sx={{
      width: "100%",
      height: { xs: "auto" },
      ...sx,
    }}
  />
);

const CustomTypography = ({ children, sx, onClick }) => (
  <Typography
    sx={{
      fontFamily: "Poppins",
      letterSpacing: "1px",
      fontSize: "15px",
      color: "gray",
      textTransform: "capitalize",
      fontWeight: 400,
      ...sx,
    }}
    onClick={onClick}
  >
    {children}
  </Typography>
);

export default function HowBarter() {
  const card = [
    {
      name: "The Ultimate Guide to Barter Exchange goods without involving money",
      description:
        "One of the oldest and most effective methods of trade that existed several centuries ago is barter which has regained popularity in the modern economy.",
      link: "/barter-exchange-goods-without-involving-money",
    },
    {
      name: "Advantages and disadvantages of the barter system of exchange",
      description:
        "Whether you are planning to start a barter business or want to understand how it works",
      link: "/advantages-and-disadvantages-of-the-barter-system-of-exchange",
    },
    {
      name: "Top 10 Best Barter trade Companies and websites in India",
      description:
        "Barter trade is a very old method of exchange where goods and services are swapped without the use of money",
      link: "/barter-trade-companies",
    },
  ];

  const iconMapping = {
    Favourites: <FavoriteIcon />,
    Share: <ShareIcon />,
    Print: <PrintIcon />,
  };

  const componentRef = useRef();
  const location = useLocation();
  const pathname = location.pathname;

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleClick = (text) => {
    if (text === "Print") {
      handlePrint();
    } else if (text === "Share") {
      navigator.clipboard.writeText(`https://bxiworld.com${pathname}`);
      toast.info("URL Copied", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  return (
    <Paper
      sx={{
        position: "relative",
        backgroundColor: "#f9f6ef",
      }}
      ref={componentRef}
    >
      <ToastContainer style={{ fontSize: "16px" }} />
      <Helmet>
        <meta charSet="utf-8" />
        <title> How the Barter System Works in India</title>
        <meta
          property="og:title"
          content=" How the Barter System Works in India"
        />
        <meta
          name="og:description"
          content=" Understand how the barter system operates in India, from traditional practices to modern trade exchanges, and how platforms like BXI are streamlining the process for businesses."
        />
        <meta
          name="description"
          content=" Understand how the barter system operates in India, from traditional practices to modern trade exchanges, and how platforms like BXI are streamlining the process for businesses."
        />
        <meta
        name="keywords"
        content=" barter system in India, Indian barter practices, modern barter in India, BXI barter platform, trade without money, barter economy in India, business barter solutions "
        />
      </Helmet>
      <Header />
      <Box sx={{ position: "relative" }}>
        <ResponsiveImage src={BannerImg} alt="Business meeting" />
        <Box
          sx={{
            position: "absolute",
            bottom: { xs: "-70px", sm: "-70px", md: "-70px" },
            width: { xs: "70%", sm: "70%", md: "65%" },
            height: { xs: "25%", sm: "25%", md: "25%" },
            bgcolor: "#f9f6ef",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            p: 4,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: {
                xs: "20px",
                sm: "25px",
                md: "35px",
                lg: "45px",
                xl: "55px",
              },
              width: {
                xs: "82%",
                sm: "82%",
                md: "82%",
                lg: "85%",
                xl: "85%",
              },
              height: {
                xs: "100%",
                sm: "100%",
              },
              fontFamily: "Poppins",
              fontWeight: 500,
              textAlign: "start",
            }}
          >
           How the Barter System Works in India
          </Typography>
        </Box>
      </Box>
      <Grid
        container
        spacing={3}
        sx={{
          mt: { xs: 15, sm: 15, md: 10 },
          px: { xs: 2, md: 4 },
        }}
      >
        <Grid item xs={12} md={8}>
          <Divider />
          <Grid container>
            <Grid
              item
              xs={12}
              md={4}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {["Favourites", "Share", "Print"].map((text, index) => (
                <CustomTypography
                  key={index}
                  sx={{
                    my: 2,
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: {
                      xs: "center",
                      sm: "center",
                      md: "flex-start",
                      lg: "flex-start",
                      xl: "flex-start",
                    },
                    alignItems: {
                      xs: "center",
                      sm: "center",
                      md: "center",
                      lg: "center",
                      xl: "center",
                    },
                    width: "50%",
                    gap: "3px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(text)}
                >
                  <IconButton>{iconMapping[text]}</IconButton>
                  {text}
                </CustomTypography>
              ))}
            </Grid>
            <Grid item xs={12} md={8}>
              <CustomTypography sx={{ py: 2 }}>
              <Box sx={{ mb: 3 }}> 
                One of humanity's oldest methods of trade, bartering was a system of
                trade employed by ancient civilizations. In its simplest terms,
                bartering means to trade one good or service for another without
                using money. Imagine a farmer trading freshly picked vegetables
                for a carpenter's hand made furniture. The age-old practice of
                this was based on simplicity and a benefit to both the giver and
                the recipient of giving, long before currency was introduced.
              </Box>
              
              <Box sx={{ mb: 2 }}> 
                In the age of modern world barter has improvised with technology
                and digital platforms and now allows businesses and people to exchange
                resources effectively. While it's not just a relic of the past, it's
                also a practical tool for saving money, wasting less and fostering great
                community & network ties.
              </Box>
              </CustomTypography>
              <Divider />
              <CustomTypography sx={{ py: 2 }}>
                <Typography variant="h4" sx={h2ypo}>
                Types of Barter Systems
                </Typography>
                <br />
                <Box sx={{ mb: 2 }}> 
                There are many different kinds of bartering, fashioned to particular needs and contexts.
                Here are the primary types of barter systems:
              </Box>              
                <Typography variant="h4" sx={h4typo}>
                1. Direct Barter (One to One)
                </Typography>
                <br />
                <Box sx={{ mb: 2 }}> 
                It is the most simple kind of barter: two parties simply exchange goods or services with
                 one another, without the use of money. For example, a farmer may trade vegetables with
                  a baker for bread. However, direct barter use requires the presence of a 'double
                   coincidence of wants,' this is less so for the wider and larger exchanges.
              </Box>                  
                <Typography variant="h4" sx={h4typo}>
                2.  Silent Trade (One to One but via another Entity)
                </Typography>
                <br />
                <Box sx={{ mb: 2 }}> 
                Silent trade, or dumb barter, is when two people exchange goods without talking
                 directly. This is often used if there are language barriers or when you have to
                  build trust before you can do anything. This type of historical barter was common
                   in cross-cultural trade, where traders would leave goods at specific spots for
                    other traders to pick up and leave their own goods as a kind of trade.
              </Box>  
                <Typography variant="h4" sx={h4typo}>
                3. Multilateral Barter (One to Many)
                </Typography>   
                <br />
                <Box sx={{ mb: 2 }}> 
                Multilateral barter involves more than three parties, and direct matching of two
                 participants isn’t necessary. Let's say a business has too much inventory; it would
                  then trade the inventory on a platform to get Trade credits, which it could use to
                   purchase other goods or services from a different party. Modern digital platforms
                    are popular systems for facilitating this system and ensuring efficiency for businesses.
              </Box>              
                <Typography variant="h4" sx={h4typo}>
                4.Corporate Barter (B2B)
                </Typography>
                <br />
                <Box sx={{ mb: 2 }}> 
                These goods are typically large, as it’s a form of barter that deals in larger media,
                advertising, or bulk product sales. In most cases, companies trade surplus assets
                or services they have with each other using a trade credit system. Corporate barter
                networks simplify these transactions and present a structured way of getting the
                most out of surplus resources.
              </Box>              
              </CustomTypography>
            </Grid>
          </Grid>
          <Box
            sx={{
              py: 2,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
           <ResponsiveImage
              src={howbarterimage}
              alt="Business meeting"
              sx={{ width: { xs: "100%", md: "90%" }, ml: { md: "auto" } }}
            />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <CustomTypography sx={{ py: 2, width: { xs: "100%", md: "60%" } }}>
            <Typography variant="h4" sx={h2ypo}>
              How Does Barter Work?
              </Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              When using bartering, you simply match what you need with what you can offer,
              and the two of you complete deals directly. Here’s a detailed step-by-step breakdown:
              </Box> 
            
             
              <Typography sx={h4typo}>1. Identify Needs and Offerings:</Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              The first party looks at what they want and what they have to offer back.
              For example, a graphic designer might offer to exchange design services
              for legal advice.
              </Box> 
              

              <Typography sx={h4typo}>2. Search for Suitable Partners:</Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              In traditional bartering, people have to manually find someone with matching
              needs and offerings. Thankfully, modern platforms, like BXI, make it easy
              for service providers and seekers to connect for this purpose.
              </Box> 
              
              <Typography sx={h4typo}>3. Negotiate Terms:</Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              They communicate and agree on the relative value, i.e. worth of the goods
              or services exchanged between them. This ensures that both sides are happy.
              </Box> 
              

              <Typography sx={h4typo}>4. Use of Trade Credits:</Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              In most cases, on platforms such as BXI, barter credits or coins are used
              to attribute value to goods or services. This eliminates the necessity
              of a direct one-to-one match and, thus, allows multilateral trades.
              </Box>   
             
              <Typography sx={h4typo}>5. Finalize and Execute the Exchange:</Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              After terms are agreed upon the exchange takes place. In the modern world,
              the platform can help with that transaction and make sure both parties
              will stick to their deal.
              </Box> 
             
              <Typography sx={h4typo}>6. Maintain Records:</Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              For businesses, it also guarantees proper documentation of the exchange
              in order to ensure transparency, and, in cases where tax has to be paid
              back, such documentation would help with compliance.
              </Box> 
            
            </CustomTypography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <CustomTypography sx={{ py: 2, width: { xs: "100%", md: "60%" } }}>
              <Typography variant="h4" sx={h2ypo}>
              Modern Barter Systems
              </Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              Digital platforms have radically changed bartering, now it is possible more
              easily and efficiently. Businesses trade goods and services through services
              like BXI in an environment structured to ensure ease. Here’s how these
              platforms work:
              </Box> 
             

              <li>
                <b>Listing Offerings:</b> <br /> You open the platform, businesses list
                their products or services on it.

              </li>
              <br />
              <li>
                <b>Browsing Needs:</b> <br />
                The platform’s marketplace allows users to search for what they need.

              </li>
              <br />
              <li>
                <b> Using Barter Credits:</b> <br />Most platforms use a system of 
                Trade Credits to value items. This eliminates the requirement of a
                 direct one-to-one match.
              </li>
              <br />
              <li>
                <b>Transaction Facilitation:</b>{" "}
                <br />
                It makes the exchange for both to have what they agreed upon.
              </li>
              <br />
            </CustomTypography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <CustomTypography sx={{ py: 2, width: { xs: "100%", md: "60%" } }}>
              <Typography variant="h4" sx={h2ypo}>
              Tax Implications of Bartering

              </Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              In many cases, the bartered goods or services are taxable income.
              Their fair market value must be reported in many countries. For
              example, in India, if a business exchanges goods worth ₹50,000
              for services, it must report the fair market value of the 
              transaction as income in its Income Tax Return (ITR).  
              </Box> 
              <li>
              To comply with tax laws, businesses should:
              </li>
              <br />
              <li>
              Be very detailed and record everything that concerns barter transactions.
              </li>
              <br />
              <li>
              Fairly and accurately, value items.
              </li>
              <br />
              <li>
              They must report these transactions in their financial statements and pay taxes.
              </li>
              <br />
            </CustomTypography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <CustomTypography sx={{ py: 2, width: { xs: "100%", md: "60%" } }}>
            <Typography variant="h4" sx={h2ypo}>
            Ethical and Practical Tips for Successful Bartering
              </Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              When you are open, fair and respectful, you will be at your best while
              bartering. Here are some essential ethical and practical tips to help
              you navigate bartering effectively:
              </Box>  
             

              <Typography sx={h4typo}>1. Be Transparent About Value  </Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              Communicate the value of your goods or services, it is obvious.
              \ A valuation based on honesty helps avoid differences and lets
               people feel that the trade is just. Find out the market value of 
               the things you’re offering so you have a basis for negotiations.
              </Box>  
              

              <Typography sx={h4typo}>2.  Build Trust </Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              The more trust you have between the two of you, the more value you get 
              out of the system as a barter. If you’re trading someone new, start 
              small to build trust in each other’s reliability. Exchanges with trusted
               partners may be repeated enabling the long term relationships.
              </Box> 
              


              <Typography sx={h4typo}>3.Use Written Agreements </Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              Although bartering is often an informal means of exchanging goods
               and services, it is best to record the terms of the barter. Simple
                written agreements such as these can prevent a dispute and reduce 
                confusion if any worries arise.
              </Box> 
             


              <Typography sx={h4typo}>4. Be Open to Negotiation </Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              Bartering is very flexible in its implementation. Be willing to adjust your
              expectations to find a win-win response. Negotiation strengthens
              collaboration and relationships between parties
              </Box> 
             

              <Typography sx={h4typo}>5. Assess Compatibility </Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              Make sure any deal being offered to you really meets your needs, and you’re
              offering something valuable to the other party as well.
              </Box> 
             

              <Typography sx={h4typo}>6. Deliver on Promises </Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              Bartering involves ethics, and it also requires honoring your agreement.
              Delivering on time and as agreed will build your credibility as a service
              or product provider.
              </Box> 
            </CustomTypography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <CustomTypography sx={{ py: 2, width: { xs: "100%", md: "60%" } }}>
              <Typography variant="h4" sx={h2ypo}>
              Barter in Times of Economic Crisis
              </Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              Bartering becomes extremely valuable, especially during economic downturns
              or unstable currency systems. When hyperinflation or deflation run high,
              people sometimes resort to bartering to get the things they need.
              </Box> 
              
              <Box sx={{ mb: 2 }}> 
              For instance, during the economic crisis, barter may be used to gain essential 
              things. It gives you a way to still trade when you have no cash or cash is unreliable.
              </Box> 
              
            </CustomTypography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <CustomTypography sx={{ py: 2, width: { xs: "100%", md: "60%" } }}>
              <Typography variant="h4" sx={h2ypo}>
              Role of Technology in Bartering

              </Typography>
              <br />
              <Box sx={{ mb: 2 }}> 
              Thanks to technology, the age-old practice of bartering has become modern, efficient,
               and accessible. Traditional face-to-face bartering often experienced difficulty in
                locating a suitable trade partner and establishing the value of goods exchanged.
                 Digital platforms and mobile apps have solved such issues, emerging to become 
                 centralized marketplaces where companies can easily connect with each other.
              </Box> 
            
              <Box sx={{ mb: 2 }}> 
              Sites like BXI are online barter platforms that use the advanced algorithms to find
               out a user's needs or what they are offering and then finds a set of other users 
               where the wants and the offerings of every user are matched as fairly as possible.
                Most of these platforms introduce either barter credit or virtual currency to
                 facilitate multilateral trades. By removing the requirement of one to one exchange
                  it opens up a number of possibilities for participants.
              </Box> 
            
              <Box sx={{ mb: 2 }}> 
              Users also have access to real-time communication, ratings, and transaction tracking
               via mobile apps and online tools, which help instil trust and transparency. 
               By making bartering transactions secure and verifiable.
              </Box> 
            
            
              <Box sx={{ mb: 2 }}> 
              By doing so, bartering is being modernized and at the same time is becoming a
               practical solution for our online world.
              </Box>             
            </CustomTypography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <CustomTypography sx={{ py: 2, width: { xs: "100%", md: "60%" } }}>
              <Typography variant="h4" sx={h2ypo}>
              Conclusion
              </Typography>
              <br />

              Trade by barter is a system of trade which has no era and no monetary system.
               Based on principles of mutual benefit, resourcefulness and community 
               connection it thrives. Bartering certainly isn’t going anywhere, whether its 
               use is to save cash, cut down on excess, or foster closer relationships,
                bartering is a helpful and usable tradition of trade. From the diverse world
                 economies, however, the basic barter value has remained the same: it is the
                  path leading to innovative methods of satisfying people’s needs among
                   people or businesses. By reading this article, you will understand the
                    mechanics of this has potential and how anyone can use bartering for 
                    sustainable growth and meaningful exchanges.

            </CustomTypography>
          </Box>


        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              width: { xs: "100%", md: "60%" },
              mt: 2,
              ml: { xs: 0, md: 3 },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Poppins",
                color: "gray",
                textTransform: "capitalize",
                fontSize: "18px",
                fontWeight: 500,
                letterSpacing: "2px",
              }}
            >
              RELATED BLOGS
            </Typography>
          </Box>
          {card.map((data, idx) => {
            const wordLimit = 4;
            function truncateText(text, wordLimit) {
              const words = text.split(" ");
              if (words.length > wordLimit) {
                return words.slice(0, wordLimit).join(" ") + "...";
              }
              return text;
            }
            return (
              <Box key={idx}>
                <a
                  href={data.link}
                  target="_blank"
                  alt="wtsp"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    cursor: "pointer",
                  }}
                  rel="noreferrer"
                >
                  <Box sx={{ position: "relative" }}>
                    <ResponsiveImage
                      src={BannerImg}
                      alt="Related exhibition"
                      sx={{
                        width: { xs: "100%", md: "65%" },
                        mt: 2,
                        ml: { xs: 0, md: 3 },
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: { xs: "-10px", sm: "-10px", md: "-10px" },
                        left: { xs: "0px", sm: "0px", md: "22px" },
                        width: { xs: "50%", sm: "50%", md: "50%" },
                        height: { xs: "15%", sm: "15%", md: "15%" },
                        bgcolor: "#f9f6ef",
                        py: 2,
                      }}
                    >
                      <Typography
                        variant="h4"
                        sx={{
                          fontSize: {
                            xs: "15px",
                            sm: "15px",
                            md: "15px",
                            lg: "20px",
                            xl: "20px",
                          },
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          color: "gray",
                          textAlign: "start",
                          width: "100%",
                        }}
                      >
                        {truncateText(data.name, wordLimit)}
                      </Typography>
                    </Box>
                  </Box>
                  <Typography
                    sx={{
                      mt: 3,
                      ml: { xs: 0, md: 3 },
                      width: { xs: "100%", md: "65%" },
                      lineHeight: "25px",
                      fontFamily: "Poppins",
                      textAlign: "start",
                      color: "#6d6f71",
                      textTransform: "capitalize",
                      fontWeight: 400,
                      fontSize: "15px",
                      letterSpacing: "1px",
                    }}
                  >
                    {data.description}
                  </Typography>
                </a>
              </Box>
            );
          })}
        </Grid>
      </Grid>
    </Paper>
  );
}

const h2ypo = {
  fontSize: {
    xs: "22px",
    sm: "22px",
    md: "27px",
    lg: "27px",
    xl: "27px",
  },
  fontFamily: "Poppins",
  fontWeight: 500,
  textAlign: "start",
};

const h4typo = {
  fontSize: {
    xs: "15px",
    sm: "15px",
    md: "20px",
    lg: "20px",
    xl: "20px",
  },
  fontFamily: "Poppins",
  fontWeight: 500,
  textAlign: "start",
};
